module.exports = __webpack_public_path__ + "img/4.17102a44.jpg";